import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import AuthInit from './components/AuthInit';
import { PermissionProvider } from './context/PermissionContext';
import { SidebarRailProvider } from './context/SidebarRailContext';
import { ThemePreferenceProvider } from './context/ThemePreferenceContext';
import AppThemeProvider from './components/theme/AppThemeProvider';
import { store } from './store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QuickNotesDock from './components/quickNotes/QuickNotesDock';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ThemePreferenceProvider>
        <AppThemeProvider>
          <BrowserRouter>
            <AuthInit>
              <PermissionProvider>
                <SidebarRailProvider>
                  <App />
                  <QuickNotesDock />
                  <ToastContainer position="top-right" autoClose={3000} theme="colored" />
                </SidebarRailProvider>
              </PermissionProvider>
            </AuthInit>
          </BrowserRouter>
        </AppThemeProvider>
      </ThemePreferenceProvider>
    </Provider>
  </ErrorBoundary>
);
